import {
  HOURS_OPTION_VALUE,
  MINUTES_OPTION_VALUE,
  DEFAULT_DURATION_UNIT,
  DURATION_UNIT_OPTIONS,
} from '../../constants';

export default function getInitialModel(userSettings, multipleAlarmsEnabled) {
  const initialUnits = getInitialUnits(userSettings);
  let alarmsModel = userSettings.shiftAlarms?.length
    ? userSettings.shiftAlarms.map((value, index) => ({
        value,
        unit: initialUnits[index] || DEFAULT_DURATION_UNIT,
      }))
    : [{ value: null, unit: initialUnits[0] }];

  if (!multipleAlarmsEnabled) {
    alarmsModel = alarmsModel.slice(0, 1);
  }

  return alarmsModel;
}

function getInitialUnits(userSettings) {
  let units = [];
  if (!('shiftAlarmsUnits' in userSettings.clientFlags)) {
    units = userSettings.clientFlags.shiftAlarmTimeBeforeInHours
      ? [HOURS_OPTION_VALUE]
      : [MINUTES_OPTION_VALUE];
  } else {
    units = userSettings.clientFlags.shiftAlarmsUnits;
  }

  return units.map((unit) => findUnitOption(unit) || DEFAULT_DURATION_UNIT);
}

function findUnitOption(unitValue) {
  return DURATION_UNIT_OPTIONS.find((option) => option.value === unitValue);
}
